import { render, staticRenderFns } from "./cucc.vue?vue&type=template&id=457a1434&scoped=true&"
import script from "./cucc.vue?vue&type=script&lang=js&"
export * from "./cucc.vue?vue&type=script&lang=js&"
import style0 from "./cucc.vue?vue&type=style&index=0&id=457a1434&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "457a1434",
  null
  
)

export default component.exports